function getFocusableTime(props) {
  return props.timeSpan.find(time => props.isActive(time)) || props.timeSpan.find(time => props.isNow(time) && !props.isDisabled(time)) || props.timeSpan.find(time => !props.isDisabled(time));
}

export { getFocusableTime };
//# sourceMappingURL=getFocusableTime.mjs.map
